import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../core'

export const RESOURCE = {
  payload: {
    description: 'Information about point of contact',
    name: 'Contact',
    partialId: PartialId.Standard.create('contact'),
  },
  type: core.quiver.Resource.Type.DmsStructure,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsStructure>

// Name
// Person
// Contact Info
